var _path, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDottedLine1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 555,
    height: 198,
    viewBox: "0 0 555 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 98L553.002 99.5",
    stroke: "rgba(0, 0, 0, 0.65)",
    strokeWidth: 1.2,
    strokeDasharray: "8 8"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 553.6,
    y1: 1.18809e-10,
    x2: 553.6,
    y2: 100,
    stroke: "rgba(0, 0, 0, 0.65)",
    strokeWidth: 1.2,
    strokeDasharray: "8 8"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.6,
    y1: 98,
    x2: 1.6,
    y2: 198,
    stroke: "rgba(0, 0, 0, 0.65)",
    strokeWidth: 1.2,
    strokeDasharray: "8 8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDottedLine1);
export default __webpack_public_path__ + "static/media/dotted_line_1.9ce5d089c25059d7eff66f114bc25f1e.svg";
export { ForwardRef as ReactComponent };